import React from 'react';
import { X, Info, AlertTriangle, CheckCircle, AlertCircle } from 'lucide-react';

const BUBBLE_CONFIG = {
  info: { icon: Info, bg: 'bg-blue-600', hoverBg: 'hover:bg-blue-700', dot: 'bg-blue-400' },
  warning: { icon: AlertTriangle, bg: 'bg-orange-500', hoverBg: 'hover:bg-orange-600', dot: 'bg-orange-300' },
  success: { icon: CheckCircle, bg: 'bg-green-600', hoverBg: 'hover:bg-green-700', dot: 'bg-green-400' },
  error: { icon: AlertCircle, bg: 'bg-red-600', hoverBg: 'hover:bg-red-700', dot: 'bg-red-400' }
};

const AnnouncementBanner = ({ announcements = [], onDismiss, onOpenDrawer }) => {
  if (announcements.length === 0) return null;

  return (
    <div className="fixed top-4 right-4 z-40 flex flex-col items-end gap-2 max-w-sm">
      {announcements.slice(0, 3).map(a => {
        const config = BUBBLE_CONFIG[a.announcement_type] || BUBBLE_CONFIG.info;
        const Icon = config.icon;

        return (
          <div
            key={a.id}
            className={`${config.bg} ${config.hoverBg} text-white rounded-full pl-3 pr-2 py-2 flex items-center gap-2 shadow-lg cursor-pointer transition-all duration-200 hover:shadow-xl hover:scale-[1.02] max-w-full`}
            onClick={onOpenDrawer}
          >
            {!a.dismissible && (a.announcement_type === 'error' || a.announcement_type === 'warning') && (
              <span className="relative flex h-2 w-2 flex-shrink-0">
                <span className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${config.dot}`} />
                <span className={`relative inline-flex rounded-full h-2 w-2 ${config.dot}`} />
              </span>
            )}
            <Icon size={16} className="flex-shrink-0" />
            <span className="text-sm font-rasa font-semibold truncate">{a.title}</span>
            {a.dismissible && onDismiss && (
              <button
                onClick={(e) => { e.stopPropagation(); onDismiss(a.id); }}
                className="opacity-60 hover:opacity-100 transition-opacity flex-shrink-0 ml-1 p-0.5 rounded-full hover:bg-white/20"
              >
                <X size={14} />
              </button>
            )}
          </div>
        );
      })}
      {announcements.length > 3 && (
        <button
          onClick={onOpenDrawer}
          className="text-xs text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 font-rasa transition-colors"
        >
          +{announcements.length - 3} more
        </button>
      )}
    </div>
  );
};

export default AnnouncementBanner;
